// extracted by css-extract-rspack-plugin
export default {"text":"PlaygroundToolCallMessage-module__text__RHoaDiI"};